<div class="custom-block-width" style="padding: 0 15px">
  <!-- <div class="map-header">
  <h2>Acyclovir Capsules 200mg</h2>
  <p class="map-header-tagline">60 | 30 Days</p>
</div> -->
<h4 class="modal-header pharmacy-header">
  Pharmacy Details
  <span class="close-icon-dialog"
    ><mat-icon (click)="close()">close</mat-icon></span
    >
  </h4>
  <div class="custom-dialog-width">
    <div class="map-info">
      <div class="mat-row" fxLayout="row" class="pharmacy-details">
        <div class="mat-6">
          <label>Pharmacy Name </label>
          <p class="value">{{ pharmacy.name }}</p>
        </div>
        <div class="mat-6">
          <label>Pharmacy Address</label>
          <p class="value">
            {{ pharmacy.address.addressLine1 }},
            {{
            pharmacy.address.addressLine2
            ? pharmacy.address.addressLine2 + ","
            : ""
            }}
            {{ pharmacy.address.city }}, {{ pharmacy.address.state }},
            {{ pharmacy.address.zipCode }}
          </p>
        </div>
      </div>
      <div class="mat-row" fxLayout="row" class="pharmacy-details">
        <div class="mat-6">
          <label>NPI </label>
          <p class="value">{{ pharmacy.npi }}</p>
          <label>Phone Number </label>
          <p class="value">
            {{
            pharmacy.phoneNumber
            ? formatPhoneNumber(pharmacy.phoneNumber)
            : "-"
            }}
          </p>
          <label>NABP </label>
          <p class="value">{{ pharmacy.nabp }}</p>
          <label>Network Pharmacy </label>
          <p class="value">{{ pharmacy.inNetwork ? "YES" : "NO" }}</p>
          <label>Distance (in Miles)</label>
          <p class="value">
            {{ pharmacy.distance ? pharmacy.distance : "-" }}
          </p>
        </div>
        <div class="mat-6">
          <label>Hours of Operation</label>

          @if (pharmacy.hours.operating24Hours) {
            <p>Operating 24 hours</p>
          }
          @if (!pharmacy.hours.operating24Hours) {
            @for (day of days; track day) {
              <p
                class="capitalize mb-0 title-12 week-block"
                [hidden]="!getDay(day)"
                >
                <span class="day-time">{{ day | titlecase }}</span>
                <span>{{ getDay(day) }}</span>
              </p>
            }
          }
          <!-- <div class="value">
          <p class="day-time"><span>Monday</span> 9 AM - 7 PM</p>
          <p class="day-time"><span>Tuesday</span> 9 AM - 7 PM</p>
          <p class="day-time"><span>Wednesday</span> 9 AM - 7 PM</p>
          <p class="day-time"><span>Thursday</span> 9 AM - 7 PM</p>
          <p class="day-time"><span>Friday</span> 9 AM - 7 PM</p>
          <p class="day-time"><span>Saturday </span> 9 AM - 5 PM</p>
          <p class="day-time"><span>Sunday </span> 9 AM - 5 PM</p>
        </div> -->
        <div class="mar-t-1">
          <label>Pharmacy Services </label>
          <p class="value">{{ pharmacy.services.join(", ") }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="mapouter">
    <app-google-map [pharmacy]="pharmacy"></app-google-map>
  </div>
</div>
</div>
